import { render, staticRenderFns } from "./PorletMenuActions.vue?vue&type=template&id=7b67293b&"
import script from "./PorletMenuActions.vue?vue&type=script&lang=js&"
export * from "./PorletMenuActions.vue?vue&type=script&lang=js&"
import style0 from "./PorletMenuActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports